﻿import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ThemeProvider } from "./context/ThemeContext";
import { ProductProgressProvider } from "./context/ProductProgressContext";
import { ProductStatsProvider } from "./context/ProductStatsContext";
import SocialDock from "./components/feature/SocialDock";
import RouteScrollReset from "./components/feature/RouteScrollReset.tsx";
import IntroSplash from "./components/feature/IntroSplash";

function App() {
  return (
    <>
      <IntroSplash />
      <ThemeProvider>
        <I18nextProvider i18n={i18n}>
          <ProductProgressProvider>
            <ProductStatsProvider>
              <BrowserRouter basename={__BASE_PATH__}>
                <RouteScrollReset />
                <AppRoutes />
                <SocialDock />
              </BrowserRouter>
            </ProductStatsProvider>
          </ProductProgressProvider>
        </I18nextProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
